import React from 'react';

export default function RecipeSearchBar({ value, onChange }) {
    return (
        <input
            type="text"
            className="recipe-search-bar"
            placeholder="Search recipes..."
            value={value}
            onChange={e => onChange(e.target.value)}
        />
    );
}
